<div class="project-tasks">
  <div class="project-tasks__content">
    @if (projectStage()) {
      <div class="project-tasks__content__process mb-4">
        <h5 class="font-weight-bold mb-4">{{ stageTitle() }}</h5>

        @if (templateLoading()) {
          <div class="d-flex align-items-center justify-content-center my-5">
            <div class="lds-dual-ring"></div>
          </div>
        } @else {
          <list-tasks-v2
            [groups]="templateGroups()"
            [loading]="templateLoading()"
            [disableGroupDrag]="true"
            (taskStatusChanged)="onTemplateTaskStatusChanged($event)"
            (taskClicked)="onTemplateTaskClicked($event)"
            (templateAddSelected)="onTemplateAddSelected($event)"
          />
        }
      </div>
    }

    <div class="ui-project__header d-flex justify-content-between align-items-center flex-wrap">
      <div class="projects-header">
        <h5 class="font-weight-bold mb-0">
          {{ 'Projects.PreviewTabs.' + taskTypeName | translate }}
        </h5>

        <div class="ml-auto">
          <div class="projects-header__inside">
            <app-button
              class="mr-2 my-1 my-lg-0"
              (onClick)="createNewTaskGroup()"
              [permission]="{ group: PermissionsGroups.PROJECTS, action: 'EDIT' }"
              [config]="{
                size: ButtonSize.SMALL,
                type: ButtonTypes.NEW_SECONDARY_BLUE,
                text: ('Projects.newGroup' | translate),
                prependSrc: './assets/img/ic-plus.svg'
              }"
            />
            <list-search />

            <list-filters-btn-v2 class="ml-auto" [filters]="ProjectTasksFiltersComponent" />
          </div>
        </div>
      </div>
    </div>

    <div class="project-tasks__content__tasks">
      @if (project()?.id && config) {
        <list-tasks
          #listTasksComponent
          [config]="config"
          [filters]="ProjectTasksFiltersComponent"
          [project]="project()"
          [projectId]="project().id"
        />
      } @else {
        <div class="d-flex align-items-center justify-content-center my-5">
          <div class="lds-dual-ring"></div>
        </div>
      }
    </div>
  </div>
</div>
